import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { religionDetailEditSchema } from '../../../ValidationSchema';
import { editReligiousSocialDetails, getAllPhysicalStatus, getCast, getDomain, getPadam, getReligion, getstars } from '../../../../asiosConfig';
import Popup from '../../../Popup';
import { Button, Card, CardContent, CardHeader, MenuItem, TextField } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const ReligionEdit = () => {
    const location = useLocation();
    const userProfileData = location.state?.userProfileData || {};
    const [domains, setDomains] = useState([]);
    const [religions, setReligions] = useState([]);
    const [communities, setCommunities] = useState([]);
    const [selectedDomain, setSelectedDomain] = useState(userProfileData.domainIDS || '');
    const [selectedReligion, setSelectedReligion] = useState(userProfileData.religionIDS || '');
    const [language, setLanguage] = useState([]);
    const [padams, setPadams] = useState([]);
    const [stars, setStars] = useState([]);
    const [popupData, setPopupData] = useState({ open: false, type: '', message: '' });

    const handleClosePopup = () => {
        setPopupData({ ...popupData, open: false });
    };

    useEffect(() => {
        if (popupData.open) {
            const timer = setTimeout(() => {
                setPopupData(prev => ({ ...prev, open: false }));
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [popupData.open]);

    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            domain: userProfileData.domainIDS || '',
            religion: userProfileData.religionIDS || '',
            Community: userProfileData.casteIDS || '',
            Sub_Community: userProfileData.subcaste || '',
            gothram: userProfileData.gothram || '',
            star: userProfileData.star || '',
            padam: userProfileData.padam || '',
            sevvaiDosham: userProfileData.sevvaiDosham || '',
            Mother_Tongue: userProfileData.MotherTongue || '',
            user_id: localStorage.getItem('user'),
            // token: localStorage.getItem('token')
        },
        validationSchema: religionDetailEditSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                const response = await editReligiousSocialDetails(values);
                if (response.status === 200 || response.status === 201) {
                    setPopupData({ open: true, type: 'success', message: response.data.message });
                    setTimeout(() => {
                        navigate(-1);
                    }, 3000);
                } else {
                    setPopupData({ open: true, type: 'error', message: response.data.message });
                }
            } catch (error) {
                setPopupData({ open: true, type: 'error', message: error.response?.data?.message || "An error occurred" });
            } finally {
                setSubmitting(false);
            }

        }
    })

    useEffect(() => {
        const fetchDomains = async () => {
            try {
                const response = await getDomain();
                if (response.status === 200 || response.status === 201) {
                    setDomains(response.data.data);
                }
            } catch (error) {
                setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
            }
        };
        const fetchLanguage = async () => {
            try {
                const response = await getAllPhysicalStatus();

                if (response.status === 200 || response.status === 201) {
                    setLanguage(response.data.data.get_language);
                } else {
                    setPopupData({ open: true, type: 'error', message: response?.data?.error });
                }

            } catch (error) {
                setPopupData({ open: true, type: 'error', message: error.data?.message || "An error occurred" });
            }
        };

        const fetchPadam = async () => {
            try {
                const response = await getPadam();
                if (response.status === 200 || response.status === 201) {
                    setPadams(response.data.data);
                } else {
                    setPopupData({ open: true, type: 'error', message: 'Failed to fetch communities' });
                }
            } catch (error) {
                setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
            }
        }

        const fetchStar = async () => {
            try {
                const response = await getstars();
                if (response.status === 200 || response.status === 201) {
                    setStars(response.data.data);
                } else {
                    setPopupData({ open: true, type: 'error', message: 'Failed to fetch communities' });
                }
            } catch (error) {
                setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
            }
        }
        fetchLanguage();
        fetchDomains();
        fetchPadam();
        fetchStar();
    }, []);

    useEffect(() => {
        const fetchReligion = async () => {
            if (formik.values.domain) {
                try {
                    const response = await getReligion(formik.values.domain);
                    if (response.status === 200 || response.status === 201) {
                        setReligions(response.data.data);

                        // Only update Religion if it's not already set from userProfileData
                        if (!userProfileData.religion_ids) {
                            formik.setFieldValue('religion', userProfileData.religionIDS);
                        }

                        // Reset dependent dropdowns
                        setCommunities([]);
                    } else {
                        setPopupData({ open: true, type: 'error', message: 'Failed to fetch religions' });
                    }
                } catch (error) {
                    setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
                }
            }
        };

        // Fetch religions only if the domain value changes
        if (formik.values.domain) {
            fetchReligion();
        }
    }, [formik.values.domain, userProfileData.religionIDS]);

    useEffect(() => {
        const fetchCommunity = async () => {
            if (formik.values.religion) {
                try {
                    const response = await getCast(formik.values.religion);
                    if (response.status === 200 || response.status === 201) {
                        setCommunities(response.data.data);

                        // Only update Community if it's not already set from userProfileData
                        if (!userProfileData.caste_ids) {
                            formik.setFieldValue('Community', userProfileData.casteIDS);
                        }

                        // Reset dependent dropdown
                    } else {
                        setPopupData({ open: true, type: 'error', message: 'Failed to fetch communities' });
                    }
                } catch (error) {
                    setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
                }
            }
        };

        // Fetch communities only if the religion value changes
        if (formik.values.religion) {
            fetchCommunity();
        }
    }, [formik.values.religion, userProfileData.casteIDS]);
    return (
        <div className="col-lg-9 col-12">
            <Card className="editProfileBlock">
                <CardHeader
                    avatar={<ArrowBackIcon sx={{ color: '#FF8008', cursor: 'pointer' }} onClick={() => navigate(-1)} />}
                    title="Religion Kundali and Astro Details"
                    subheader="Update your Religion details to get suitable matches"
                    titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }}
                />
                <CardContent>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    select
                                    label="Domain"
                                    variant="outlined"
                                    className="mb-3"
                                    name="domain"
                                    value={formik.values.domain}
                                    onChange={(e) => {
                                        formik.handleChange(e);
                                        setSelectedDomain(e.target.value);
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.domain && Boolean(formik.errors.domain)}
                                    helperText={formik.touched.domain && formik.errors.domain}
                                >
                                    <MenuItem value="">Select Domain</MenuItem>
                                    {domains.map((domain) => (
                                        <MenuItem key={domain.id} value={domain.id}>{domain.domain}</MenuItem>
                                    ))}
                                </TextField>
                            </div>

                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    select
                                    label="Religion"
                                    variant="outlined"
                                    className="mb-3"
                                    name="religion"
                                    value={formik.values.religion}
                                    onChange={(e) => {
                                        formik.handleChange(e);
                                        setSelectedReligion(e.target.value);
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.religion && Boolean(formik.errors.religion)}
                                    helperText={formik.touched.religion && formik.errors.religion}
                                >
                                    <MenuItem value="">Select Religion</MenuItem>
                                    {religions.map((religion) => (
                                        <MenuItem key={religion.id} value={religion.id}>{religion.religion} ({religion.domain})</MenuItem>
                                    ))}
                                </TextField>
                            </div>

                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    select
                                    label="Community"
                                    variant="outlined"
                                    className="mb-3"
                                    name="Community"
                                    value={formik.values.Community}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.Community && Boolean(formik.errors.Community)}
                                    helperText={formik.touched.Community && formik.errors.Community}
                                >
                                    <MenuItem value="">Select Community</MenuItem>
                                    {communities.map((community) => (
                                        <MenuItem key={community.id} value={community.id}>{community.caste} ({community.religion})</MenuItem>
                                    ))}
                                </TextField>
                            </div>

                            {/* Add other fields similarly if needed */}
                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    label="Sub Community"
                                    variant="outlined"
                                    className="mb-3"
                                    name="Sub_Community"
                                    value={formik.values.Sub_Community}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.Sub_Community && Boolean(formik.errors.Sub_Community)}
                                    helperText={formik.touched.Sub_Community && formik.errors.Sub_Community}
                                    InputProps={{
                                        style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                                        inputProps: {
                                            style: { textAlign: 'center' }, // Center-aligns text in the input field
                                        },
                                    }}
                                />
                            </div>

                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    label="Gothram"
                                    variant="outlined"
                                    className="mb-3"
                                    name="gothram"
                                    value={formik.values.gothram}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.gothram && Boolean(formik.errors.gothram)}
                                    helperText={formik.touched.gothram && formik.errors.gothram}
                                    InputProps={{
                                        style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                                        inputProps: {
                                            style: { textAlign: 'center' }, // Center-aligns text in the input field
                                        },
                                    }}
                                />
                            </div>

                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    select
                                    label="Star"
                                    variant="outlined"
                                    className="mb-3"
                                    name="star"
                                    value={formik.values.star}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.star && Boolean(formik.errors.star)}
                                    helperText={formik.touched.star && formik.errors.star}
                                >
                                    <MenuItem value="">Select Star</MenuItem>
                                    {stars.map((value) => (
                                        <MenuItem key={value.id} value={value.id}>{value.star}</MenuItem>
                                    ))}
                                </TextField>
                            </div>

                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    select
                                    label="Padam"
                                    variant="outlined"
                                    className="mb-3"
                                    name="padam"
                                    value={formik.values.padam}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.padam && Boolean(formik.errors.padam)}
                                    helperText={formik.touched.padam && formik.errors.padam}
                                >
                                    <MenuItem value="">Select Padam</MenuItem>
                                    {padams.map((value) => (
                                        <MenuItem key={value.id} value={value.id}>{value.padam}</MenuItem>
                                    ))}
                                </TextField>
                            </div>

                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    select
                                    label="Sevvai Dosham"
                                    variant="outlined"
                                    className="mb-3"
                                    name="sevvaiDosham"
                                    value={formik.values.sevvaiDosham}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.sevvaiDosham && Boolean(formik.errors.sevvaiDosham)}
                                    helperText={formik.touched.sevvaiDosham && formik.errors.sevvaiDosham}
                                >
                                    <MenuItem value="">Select Sevvai Dosham</MenuItem>
                                    <MenuItem value="yes">Yes</MenuItem>
                                    <MenuItem value="no">No</MenuItem>
                                </TextField>
                            </div>

                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    select
                                    label="Mother Tongue"
                                    variant="outlined"
                                    className="mb-3"
                                    name="Mother_Tongue"
                                    value={formik.values.Mother_Tongue}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.Mother_Tongue && Boolean(formik.errors.Mother_Tongue)}
                                    helperText={formik.touched.Mother_Tongue && formik.errors.Mother_Tongue}
                                >
                                    <MenuItem value="">Select Mother Tongue</MenuItem>
                                    {language.map((value, index) => (
                                        <MenuItem key={index} value={value.id}>
                                            {value.language}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </div>
                        </div>

                        {/* <div className="d-grid col-4 mx-auto mt-2"> */}
                        <Button type="submit" variant="contained" sx={{ backgroundColor: '#FF8008' }}>
                            {formik.isSubmitting ? 'Saving...' : 'Save Changes'}
                        </Button>
                        {/* </div> */}
                    </form>
                </CardContent>
            </Card>

            <Popup
                open={popupData.open}
                type={popupData.type}
                message={popupData.message}
                onClose={handleClosePopup}
            />
        </div >
    )
}
